import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, GridWrap, InfoWrapper, Table } from 'components';
import {
  FieldType,
  MediaGroup,
  SchemaPonteCommonTableValue,
  UploadMedia,
} from 'constants/inspections';
import { tipologiaGuardaviaOptions } from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import GuardavieForm from './GuardavieForm';
const GuardavieSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const sovrastrutturaImpalcatoTableGuardavieTableWatch = watch(
    `sovrastrutturaImpalcatoTable[${selectedIdx}].guardavieTable`
  );

  // table setup
  const dataConfigGuardavie = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaGuardavia: {
        label: 'Tipologia Guardiavia',
        format: tipologiaGuardaviaOptions,
      },
      tipologiaAltroGuardavia: {
        label: 'Tipologia Guardiavia (Altro)',
      },
      altezzaGuardavia: {
        label: 'H [cm]',
      },
      superficieGuardavia: {
        label: 'S [m²]',
      },
    },
  };

  // guardavie setup
  const [selectedGuardavie, setSelectedGuardavie] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsGuardavie = item => {
    setValue('l0t3a2_guardaviaTableValue', [item]);
    setValue('l0t3a2_tipologiaGuardaviaTableValue', item.tipologiaGuardavia);
    setValue(
      'l0t3a2_tipologiaAltroGuardaviaTableValue',
      item.tipologiaAltroGuardavia
    );
    setValue('l0t3a2_altezzaGuardaviaTableValue', item.altezzaGuardavia);
    setValue('l0t3a2_superficieGuardaviaTableValue', item.superficieGuardavia);
  };

  const handleSelectAllClickGuardavie = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].guardavieTable`
      );
      const filteredValue = selectedValue.filter(
        el => el.presenza === SchemaPonteCommonTableValue.Uno
      );
      setSelectedGuardavie(filteredValue);
      setValue('l0t3a2_guardaviaTableValue', filteredValue);
    } else {
      setSelectedGuardavie([]);
      setValue('l0t3a2_guardaviaTableValue', []);
    }
  };

  return (
    <>
      <InfoWrapper
        isDivider={true}
        size={12}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoGuardavie.drawerTitle}
        drawerText={INFO.impalcatoGuardavie.drawerText}
      >
        <Divider sx={{ marginTop: 3 }}>GUARDAVIE</Divider>
      </InfoWrapper>
      {sovrastrutturaImpalcatoTableGuardavieTableWatch?.length === 0 && (
        <GridWrap item xs={12}>
          <Typography>Nessun guardavia previsto in questo elemento</Typography>
        </GridWrap>
      )}
      {sovrastrutturaImpalcatoTableGuardavieTableWatch?.every(
        el => el.assente
      ) &&
        sovrastrutturaImpalcatoTableGuardavieTableWatch?.length > 0 && (
          <GridWrap item xs={12}>
            <Typography>
              Nessun guardavia presente in questo elemento
            </Typography>
          </GridWrap>
        )}
      {sovrastrutturaImpalcatoTableGuardavieTableWatch?.filter(
        el => !el.assente
      ).length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <GuardavieForm
              guardavieFields={
                sovrastrutturaImpalcatoTableGuardavieTableWatch || []
              }
              selected={selectedGuardavie}
              setSelected={setSelectedGuardavie}
              guardavieTable={`sovrastrutturaImpalcatoTable[${selectedIdx}].guardavieTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Guardavie'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`sovrastrutturaImpalcatoTable[${selectedIdx}].guardavieTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Sovrastruttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={
                  sovrastrutturaImpalcatoTableGuardavieTableWatch.filter(
                    el => !el.assente
                  ) || []
                }
                config={dataConfigGuardavie}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsGuardavie(item);
                            setSelectedGuardavie([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        sovrastrutturaImpalcatoTableGuardavieTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedGuardavie}
                onSelectAllClick={handleSelectAllClickGuardavie}
                setSelected={setSelectedGuardavie}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
GuardavieSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default GuardavieSection;
